import { css } from 'styled-components';
import { f as focusOutline } from './focusOutline-DNwtedBp.js';

const focusPseudoElementsAfter = /*#__PURE__*/css(["::after{content:\"\";position:absolute;top:0;bottom:0;left:0;right:0;", " z-index:1;pointer-events:none;}"], focusOutline);

export { focusPseudoElementsAfter as f };
//# sourceMappingURL=focusPseudoElementsAfter-DYbe7tJD.js.map
